import React from "react";
import { Link } from "react-router-dom";
import { Users, ListChecks, Settings, Calendar, Activity } from "lucide-react";

const links = [
  { icon: <Activity />, label: "Daily Recap", to: "/recap" },
  { icon: <Users />, label: "Clients", to: "/clients" },
  { icon: <ListChecks />, label: "Tasks", to: "/tasks" },
  { icon: <Calendar />, label: "Calendar", to: "/calendar" },
  { icon: <Settings />, label: "Settings", to: "/settings" },
];

const SectionLinks = () => (
  <div className="bg-white rounded-2xl shadow p-6 border-t-4" style={{ borderTopColor: "#FFB800" }}>
    <div className="text-lg font-semibold text-[#172A3A] mb-4">Sections</div>
    <div className="grid grid-cols-2 gap-4">
      {links.map(l => (
        <Link key={l.label} to={l.to} className="flex flex-col items-center justify-center p-4 rounded-xl bg-[#F7FAFC] hover:bg-[#FFF7DF] transition">
          <div className="mb-2">{l.icon}</div>
          <span className="text-sm font-bold text-[#172A3A]">{l.label}</span>
        </Link>
      ))}
    </div>
  </div>
);

export default SectionLinks;
